module.exports = __webpack_public_path__ + "static/img/009城市名片9.58cb0b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/009城市名片9.jpg
// module id = BYr0
// module chunks = 0